<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "ChatModel",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'chatModel:add',
        update: 'chatModel:update',
        delete: 'chatModel:delete',
        deleteBatch: 'chatModel:deleteBatch'
      },
      url: {
        get: '/chatModel/listByCondition',
        add: '/chatModel/add',
        update: '/chatModel/update',
        delete: '/chatModel/delete/',
        delete_batch: '/chatModel/deleteBatch',
        status: '/chatModel/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'modelName',
        label: '模型名称',
        show: true,
        width: '',
      }, {
        field: 'modelDescribe',
        label: '模型详细信息',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '模型',
        updateTitle: '模型',
        model: [ {
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'modelName',
          label: '模型名称',
          type: 'input',
          placeholder: '模型名称',
          rules: [{message: '请输入模型名称', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'modelDescribe',
          label: '模型详细信息',
          type: 'editor',
          placeholder: '模型详细信息',
          rules: [{message: '请输入模型详细信息', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
